module.exports = __webpack_public_path__ + "media/images/badges/clean-transport-100-6a98d577389e95b8336ae7d3196ee028.svg";